import { useEffect } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

export const Lightbox = ({ open, onClose, src, caption, onPrev, onNext, contain = false }) => {
  useEffect(() => {
    if (!window.__lenis) return undefined;
    if (open) window.__lenis.stop();
    else window.__lenis.start();
    return undefined;
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent
        data-lenis-prevent
        data-testid="lightbox"
        className="max-w-[min(1200px,94vw)] w-full border-0 bg-[#0A2A33] p-0 rounded-[24px] sm:rounded-[24px] overflow-hidden [&>button]:hidden"
      >
        <DialogTitle className="sr-only">{caption}</DialogTitle>
        <div className={`relative ${contain ? "bg-white" : ""}`}>
          {src && <img src={src} alt={caption} className={`mx-auto max-h-[80vh] w-full ${contain ? "object-contain" : "object-cover"}`} />}
          <button onClick={onClose} data-testid="lightbox-close" aria-label="Close" className="absolute top-3 end-3 grid h-10 w-10 place-items-center rounded-full bg-black/60 text-white hover:bg-black/80 transition-colors">
            <X className="h-4 w-4" />
          </button>
          {onPrev && (
            <div className="absolute inset-y-0 inset-x-3 flex items-center justify-between pointer-events-none" dir="ltr">
              <button onClick={onPrev} data-testid="lightbox-prev" aria-label="Previous" className="pointer-events-auto grid h-11 w-11 place-items-center rounded-full bg-white/85 text-[#1E1A16] hover:bg-white transition-colors"><ChevronLeft className="h-5 w-5" /></button>
              <button onClick={onNext} data-testid="lightbox-next" aria-label="Next" className="pointer-events-auto grid h-11 w-11 place-items-center rounded-full bg-white/85 text-[#1E1A16] hover:bg-white transition-colors"><ChevronRight className="h-5 w-5" /></button>
            </div>
          )}
        </div>
        <p className="px-5 py-4 text-[12px] uppercase tracking-[0.24em] text-[#7FD9D6]" data-testid="lightbox-caption">{caption}</p>
      </DialogContent>
    </Dialog>
  );
};
